import { Box, ScrollArea } from "@mantine/core";
import type { ReactNode } from "react";

export default function ModalContent({ children }: { children: ReactNode }) {
  return (
    <ScrollArea>
      <Box p="lg">{children}</Box>
    </ScrollArea>
  );
}
